import { effect, signal } from "@preact/signals";
import { IS_BROWSER } from "$fresh/runtime.ts";

const address = signal({
  postalCode: "",
  city: "",
});

const loading = signal(false);

const COOKIE_KEY = "shipping_address";

// Get address information when page loads
const dispose = effect(() => {
  if (loading.value) return;

  if (IS_BROWSER) {
    const cookie = localStorage.getItem(COOKIE_KEY);
    const data = JSON.parse(cookie ?? "{}");

    if (!data.postalCode) return;

    if (data.city) {
      address.value = data;
      return;
    } else {
      loading.value = true;

      try {
        fetch(
          `https://brasilapi.com.br/api/cep/v1/${data.postalCode}`,
        )
          .then((res) => res.json())
          .then((data) => {
            localStorage.setItem(
              COOKIE_KEY,
              JSON.stringify({
                postalCode: data.cep,
                city: data.city,
              }),
            );

            address.value = {
              postalCode: data.cep,
              city: data.city,
            };
          });
      } finally {
        loading.value = false;
      }
    }
  }
});

dispose();

const setAddress = async (postalCode: string) => {
  if (
    loading.value ||
    postalCode.length < 8 ||
    postalCode === address.value.postalCode
  ) {
    return;
  }

  loading.value = true;

  try {
    const result = await fetch(
      `https://brasilapi.com.br/api/cep/v1/${postalCode}`,
    );
    const data = await result.json();

    if (!data) return;

    localStorage.setItem(
      COOKIE_KEY,
      JSON.stringify({
        postalCode: data.cep,
        city: data.city,
      }),
    );

    address.value = {
      postalCode: data.cep,
      city: data.city,
    };

    loading.value = false;
  } catch {
    throw new Error("Unexpected error!");
  }
};

export { address, loading, setAddress };
